module.exports = __webpack_public_path__ + "5fb7dadef9c9f02a34414f0ee174e2a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/domini.png
// module id = 1425
// module chunks = 0